import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { NgxPermissionsModule } from 'ngx-permissions';

import { authGuard } from './core/guards/auth.guard';
import { WebWorkflowGuard } from './core/guards/web-workflow.guard';
import { PrintLabelComponent } from './modules/new-goods-labelling/components/print-label/print-label.component';
import { ShippingCarriersHomeComponent } from './modules/shipping-carriers/components/shipping-carriers-home/shipping-carriers-home.component';
import { WarehouseManagementModule } from './modules/warehouse-management/warehouse-management.module';
import { NavigationMobileComponent } from './shared/features/layout/components/navigation-mobile/navigation-mobile.component';
import { NavigationWebComponent } from './shared/features/layout/components/navigation-web/navigation-web.component';

const isWeb = window.innerWidth > 768;

export const routes: Routes = [
  {
    path: '',
    component: isWeb ? NavigationWebComponent : NavigationMobileComponent,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },

      {
        path: 'dashboard',
        loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule),
        data: { breadcrumb: 'Inquiry' }
      },

      {
        path: 'inquiries',
        loadChildren: () => import('./modules/inquiries/inquiry.module').then(m => m.InquiryModule),
        data: { breadcrumb: 'Inquiries' }
      },

      {
        path: 'work-items',
        loadChildren: () =>
          import('./modules/work-management/features/work-items/work-items.module').then(m => m.WorkItemsModule),
        data: { breadcrumb: 'Work' }
      },

      {
        path: 'movements',
        loadChildren: () => import('./modules/movements/movements.module').then(m => m.MovementsModule),
        data: { breadcrumb: 'Movement' }
      },

      {
        path: 'Countings',
        loadChildren: () => import('./modules/counting/counting.module').then(m => m.CountingModule),
        data: { breadcrumb: 'Movement' }
      },

      {
        path: 'movement-orders',
        loadChildren: () =>
          import('./modules/movements/features/movement-orders/movement-order.module').then(m => m.MovementOrderModule),
        data: { breadcrumb: 'Inventory Management' }
      },

      {
        path: 'quick-relocation',
        loadChildren: () =>
          import('./modules/movements/features/quick-relocations/quick-relocation.module').then(
            m => m.QuickRelocationModule
          )
      },

      {
        path: 'quick-transfer-order',
        loadChildren: () =>
          import('./modules/outbound/features/quick-transfer-orders/quick-transfer-order.module').then(
            m => m.QuickTransferOrderModule
          )
      },

      {
        path: 'purchase',
        loadChildren: () =>
          import('./modules/inbound/features/purchase-receive-order/purchase-receive-order.module').then(
            m => m.PurchaseReceiveOrderModule
          ),
        data: { breadcrumb: 'Purchase Order' }
      },

      {
        path: 'transfer',
        loadChildren: () =>
          import('./modules/inbound/features/transfer-receive-order/transfer-receive-order.module').then(
            m => m.TransferReceiveOrderModule
          ),
        data: { breadcrumb: 'Inventory Management' }
      },

      {
        path: 'transfer-orders',
        loadChildren: () =>
          import('./modules/outbound/features/transfer-orders/transfer-order.module').then(m => m.TransferOrderModule),
        data: { breadcrumb: 'Inventory Management' }
      },
      {
        path: 'worklists',
        loadChildren: () =>
          import('./modules/work-management/features/worklist/worklist.module').then(m => m.WorklistModule),
        data: { breadcrumb: 'Worklists' }
      },
      {
        path: 'dispatch-order',
        loadChildren: () =>
          import('./modules/outbound/features/dispatch-orders/dispatch-order.module').then(m => m.DispatchOrderModule),
        data: { breadcrumb: 'Dispatch Order' }
      },

      {
        path: 'sales-dispatch-orders',
        loadChildren: () =>
          import('./modules/outbound/features/sales-dispatch-orders/sales-dispatch-order.module').then(
            m => m.SalesDispatchOrderModule
          ),
        data: { breadcrumb: 'Sales Dispatch Orders' }
      },

      {
        path: 'sales-orders',
        loadChildren: () =>
          import('./modules/outbound/features/sales-orders/sales-order.module').then(m => m.SalesOrderModule),
        data: { breadcrumb: 'Sales Orders' }
      },

      {
        path: 'inventory',
        loadChildren: () => import('./modules/inventory/inventory.module').then(m => m.InventoryModule),
        data: { breadcrumb: 'Inventory Management' }
      },

      {
        path: 'warehouse-management',
        loadChildren: () =>
          import('./modules/warehouse-management/warehouse-management.module').then(m => m.WarehouseManagementModule),
        data: { breadcrumb: 'Warehouse Management' }
      },

      {
        path: 'carriers',
        component: ShippingCarriersHomeComponent,
        data: { breadcrumb: 'Carriers' }
      },

      {
        path: 'new-goods-labelling',
        component: PrintLabelComponent,
        data: { breadcrumb: 'New Goods Labelling' }
      },

      {
        path: 'counting',
        loadChildren: () => import('./modules/counting/counting.module').then(m => m.CountingModule),
        data: { breadcrumb: 'Inventory Management' }
      }
    ]
  }
];
@NgModule({
  imports: [WarehouseManagementModule, RouterModule.forRoot(routes)],
  exports: [RouterModule, NgxPermissionsModule]
})
export class AppRoutingModule {}
